import React from 'react';
import type { ReactNode } from 'react';

import { HEADER_BANNER_LINK_DATA_TEST_ID } from '../constants';
import styles from './headerBanner.module.css';

interface IOptionalClickable {
  children: ReactNode;
  href?: string;
}

export const OptionalClickable = (props: IOptionalClickable): JSX.Element => {
  const { children, href } = props;

  if (!href) return <>{children}</>;

  return (
    <a
      className={styles.link}
      href={href}
      target="_blank"
      data-testid={HEADER_BANNER_LINK_DATA_TEST_ID}
      rel="noreferrer"
    >
      {children}
    </a>
  );
};
